import { Action, createAction, handleActions } from "redux-actions";
import {
  GetOficinasResponse,
  GetUsuarioResponse,
  OficinaResponse,
} from "~api/types";
import { GetRolesResponse } from "~api/roles";
import { Services } from "../types";

interface GetOficinasCompletedPayload {
  oficinas: OficinaResponse[];
}

interface GetRolesCompletedPayload {
  roles: string[];
}

interface UsuarioEditorState {
  usuario: GetUsuarioResponse | null;
  oficinas: OficinaResponse[];
  isLoading: boolean;
  failed: boolean;
  roles: string[];
}

const setInitialState = createAction("SET_USUARIOS_INITIAL_STATE");

const getOficinasInited = createAction("OBTENER_OFICINAS_INITED");
const getRolesInited = createAction("GET_ROLES_INITED");

const getOficinas = () => {
  return async (
    dispatch: (action: any) => void,
    getState: () => any,
    services: Services
  ) => {
    try {
      dispatch(getOficinasInited());

      const response = await services.api.oficinas().getOficinas();

      dispatch(getOficinasCompleted(response));
    } catch (error) {
      console.error(error);
      dispatch(getOficinasFailed(error));
    }
  };
};

const getOficinasCompleted = createAction(
  "OBTENER_OFICINAS_COMPLETED",
  (
    response: GetOficinasResponse | null | undefined
  ): GetOficinasCompletedPayload => {
    let oficinas: OficinaResponse[] = [];

    if (response != null) {
      oficinas = response.oficinas;
    }

    return { oficinas };
  }
);

const getOficinasFailed = createAction(
  "OBTENER_OFICINAS_FAILED",
  (error: unknown) => ({
    error,
  })
);

const getRoles = () => {
  return async (
    dispach: (action: any) => void,
    getState: () => any,
    services: Services
  ) => {
    try {
      dispach(getRolesInited());
      const response = await services.api.roles().getRoles();
      dispach(getRolesCompleted(response));
    } catch (error) {
      console.error(error);
      dispach(getRolesFailed(error));
    }
  };
};

const getRolesCompleted = createAction(
  "GET_ROLES_COMPLETED",
  (response: GetRolesResponse | null | undefined): GetRolesCompletedPayload => {
    let roles: string[] = [];
    if (response != null) {
      roles = response.items;
    }

    return { roles };
  }
);

const getRolesFailed = createAction("GET_ROLES_FAILED", (error: unknown) => ({
  error,
}));

const usuarioEditorInitialState: UsuarioEditorState = {
  usuario: null,
  oficinas: [],
  isLoading: true,
  failed: false,
  roles: [],
};

const usuarioEditorReducer = handleActions<UsuarioEditorState, any>(
  {
    [setInitialState.toString()]: (): UsuarioEditorState => {
      return {
        ...usuarioEditorInitialState,
        usuario: null,
        oficinas: [],
      };
    },
    [getOficinasInited.toString()]: (
      state: UsuarioEditorState
    ): UsuarioEditorState => {
      return {
        ...state,
        isLoading: true,
      };
    },
    [getOficinasCompleted.toString()]: (
      state: UsuarioEditorState,
      action: Action<GetOficinasCompletedPayload>
    ): UsuarioEditorState => {
      return {
        ...state,
        oficinas: action.payload.oficinas,
        isLoading: false,
        failed: false,
      };
    },
    [getOficinasFailed.toString()]: (
      state: UsuarioEditorState
    ): UsuarioEditorState => {
      return {
        ...state,
        isLoading: false,
        failed: true,
      };
    },
    [getRolesInited.toString()]: (
      state: UsuarioEditorState
    ): UsuarioEditorState => {
      return {
        ...state,
        isLoading: true,
      };
    },
    [getRolesCompleted.toString()]: (
      state: UsuarioEditorState,
      action: Action<GetRolesCompletedPayload>
    ): UsuarioEditorState => {
      return {
        ...state,
        roles: action.payload.roles,
        isLoading: false,
        failed: false,
      };
    },
    [getRolesFailed.toString()]: (
      state: UsuarioEditorState
    ): UsuarioEditorState => {
      return {
        ...state,
        isLoading: false,
        failed: true,
      };
    },
  },
  usuarioEditorInitialState
);

export { usuarioEditorReducer };
export { getOficinas, getRoles };
